// extracted by mini-css-extract-plugin
module.exports = {"CATALOG_SIDE_PADDING_V2":"56px","container":"MegaMenu_container__KwU2g"};